<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-800">
          <div class="modal-header">
            <slot name="header">
              New Personnel
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-2">
                  <label for="name">Name:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    ref="personnel_name"
                    name="name"
                    placeholder="name"
                    v-model="name"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="position">Position:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="position"
                    ref="personnel_position"
                    name="position"
                    placeholder="position"
                    v-model="position"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h3>Address</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address1">Address 1:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    ref="personnel_address_line_1"
                    id="address1"
                    name="address1"
                    placeholder=""
                    v-model="address_line_1"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address2">Address 2:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="address2"
                    name="address2"
                    ref="personnel_address_line_2"
                    placeholder=""
                    v-model="address_line_2"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address3">Address 3:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="address3"
                    name="address3"
                    ref="personnel_address_line_3"
                    placeholder=""
                    v-model="address_line_3"
                  />
                </div>
              </div>
              <div class="row">
                <div class=" col-2">
                  <label for="city">City:</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="city"
                    ref="personnel_address_city"
                    name="city"
                    placeholder="city"
                    v-model="address_city"
                  />
                </div>
                <div class=" col-1">
                  <label for="state">State:</label>
                </div>
                <div class="col-1 no-padding">
                  <input
                    type="text"
                    class="form-control"
                    id="state"
                    name="state"
                    ref="personnel_address_state"
                    placeholder="state"
                    v-model="address_state"
                  />
                </div>
                <div class=" col-2">
                  <label for="postcode">Postcode:</label>
                </div>
                <div class="col-1 no-padding">
                  <input
                    type="text"
                    class="form-control"
                    id="postcode"
                    name="postcode"
                    ref="personnel_address_postcode"
                    placeholder="0000"
                    v-model="address_postcode"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h3>Other Details</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="phone">Phone:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="phone"
                    ref="personnel_phone"
                    name="phone"
                    placeholder="phone"
                    v-model="phone"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="mobile">Mobile:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="mobile"
                    ref="personnel_mobile"
                    name="mobile"
                    placeholder="mobile"
                    v-model="mobile"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="email">Email:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    ref="personnel_email"
                    name="email"
                    placeholder="email"
                    v-model="email"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="notes">Notes:</label>
                </div>
                <div class="col-9">
                  <textarea
                    rows="4"
                    class="form-control"
                    id="notes"
                    ref="personnel_notes"
                    name="notes"
                    placeholder="notes"
                    v-model="notes"
                  />
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NewPersonnelModal",
  data: () => ({
    name: "",
    position: "",
    address_line_1: "",
    address_line_2: "",
    address_line_3: "",
    address_city: "",
    address_state: "",
    address_postcode: "",
    phone: "",
    mobile: "",
    email: "",
    notes: "",
  }),
  methods: {
    ...mapActions("personnels", ["apiCreatePersonnel"]),
    _save() {
      if (!this.$refs.personnel_name.value) {
        alert("please enter a name");
        return;
      }
      var personnel = {
        id: 0,
        name: this.$refs.personnel_name.value,
        position: this.$refs.personnel_position.value,
        address: {
          id: 0,
          address1: this.$refs.personnel_address_line_1.value,
          address2: this.$refs.personnel_address_line_2.value,
          address3: this.$refs.personnel_address_line_3.value,
          city: this.$refs.personnel_address_city.value,
          state: this.$refs.personnel_address_state.value,
          postcode: this.$refs.personnel_address_postcode.value,
        },
        phone: this.$refs.personnel_phone.value,
        mobile: this.$refs.personnel_mobile.value,
        email: this.$refs.personnel_email.value,
        notes: this.$refs.personnel_notes.value,
        active: true,
      };
      this.apiCreatePersonnel(personnel);
      this.$emit("close");
    },
    clear() {
      this.name = "";
      this.position = "";
      this.address_line_1 = "";
      this.address_line_2 = "";
      this.address_line_3 = "";
      this.address_city = "";
      this.address_state = "";
      this.address_postcode = "";
      this.phone = "";
      this.email = "";
      this.notes = "";
    },
  },
  components: {},
};
</script>
